import {
  flattenPadZeroRemainingTime,
  FlatTimeValuesWithRemaining,
  useRemainingTime,
} from '@aboutyou/i18n';

type CountDownValues = FlatTimeValuesWithRemaining & {
  hideCountdown?: boolean;
};

/**
 * Hook that will count down seconds towards a given end date
 * @param endDate timestamp as Date to count start from
 * @param endDate timestamp as Date to count down to
 * @returns tuple with strings for [DAYS?, HOURS, MINUTES, SECONDS, MILLIS_RAW]
 */
export const useCountdown = (endDate: Date): CountDownValues => {
  const remaining = useRemainingTime(endDate);

  if (remaining === undefined) {
    const undefinedRemaining: CountDownValues = ['00', '00', '00', '00'];
    undefinedRemaining.hideCountdown = true;
    return undefinedRemaining;
  }

  return flattenPadZeroRemainingTime(remaining);
};
